var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.30159 0.333374C1.56826 0.333374 0.974929 0.933374 0.974929 1.66671L0.968262 12.3334C0.968262 13.0667 1.56159 13.6667 2.29493 13.6667H10.3016C11.0349 13.6667 11.6349 13.0667 11.6349 12.3334V4.33337L7.63493 0.333374H2.30159ZM6.96826 5.00004V1.33337L10.6349 5.00004H6.96826Z",
    fill: "#FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/FileIcon.3d2254bb.svg";
export { ForwardRef as ReactComponent };